import AbstractType from "@/application/typeConfig/AbstractTypeConfig.ts";
import type {StepperItem} from "@/domain/type/config.type.ts";
import {RouteEnum} from "@/router/RouteEnum.ts";
import router from "@/router/router.ts";
import {SynchroType} from "@/domain/type/synchro.type.ts";
import {Source} from "@/domain/type/source.type.ts";
import {useWorkflowStore} from "@/stores/workflow.store.ts";

export default class CourseConfig extends AbstractType {
  private workflowStore = useWorkflowStore();

  getStepperItems(): StepperItem[] {
    return [
      {
        disabled: false,
        route: RouteEnum.SyncWithoutOwner,
        icon: "mdi-school",
        title: "Action de formation",
        action: () => router.push(this.getRoute(RouteEnum.SyncWithoutOwner))
      },
      {
        disabled: false,
        route: RouteEnum.SyncWithOwner,
        icon: "mdi-calendar-clock",
        title: "Séances",
        action: () => router.push(this.getRoute(RouteEnum.SyncWithOwner))
      }
    ]
  }

  sourceLeftList(): Source[] {
    return [Source.EVA];
  }

  sourceRightList(): Source[] {
    return [Source.AMMON];
  }

  cleanFieldValue(value: string, label: string): string {
    if (label.toUpperCase() === 'SITE') {
      try {
        if (!value) {
          return '';
        }
        const parsedValue = JSON.parse(value);
        return parsedValue?.name ?? value;
      } catch (e) {
        return value;
      }
    }
    return value;
  }

  private getRoute(routeName: RouteEnum): any {
    switch (routeName) {
      case RouteEnum.SyncWithoutOwner:
        return {
          name: RouteEnum.SyncWithoutOwner,
          params: {
            type: SynchroType.COURSE,
          },
          query: {
            _r: Date.now()
          }
        }
      case RouteEnum.SyncWithOwner:
        return {
          name: RouteEnum.SyncWithOwner,
          params: {
            ownerId: this.workflowStore.courseNumGroup || this.workflowStore.courseId,
            type: SynchroType.SESSIONS
          }
        }
    }
  }
}
